import { useEffect, useState } from "react";
import { Siren } from "lucide-react";
import { fetchAlerts } from "../../lib/newsApi";
import { safeUrl } from "../../lib/safeUrl";
import { timeAgo } from "../../lib/tone";
import { SideChip } from "./NewsCard";

const TYPES = [["", "All"], ["breaking", "Breaking"], ["investigation", "Investigations"], ["local", "Local"], ["politics", "Politics"], ["environment", "Environment"]];

export const AlertsView = ({ onOpenStory, refreshKey }) => {
  const [type, setType] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); fetchAlerts({ type: type || undefined, hours: 24 }).then(setData).catch(() => setData({ items: [], counts: {} })); }, [type, refreshKey]);
  return (
    <div data-testid="alerts-view">
      <h2 className="font-serif text-2xl text-slate-900">Alerts · last 24 hours</h2>
      <p className="mt-1 text-sm text-slate-500">Breaking news, new investigations, local safety notices, and politics and environment developments, detected from headlines every 15 minutes.</p>
      <div className="mt-4 flex flex-wrap gap-2" role="tablist">
        {TYPES.map(([v, l]) => (
          <button key={l} role="tab" aria-selected={type === v} onClick={() => setType(v)} data-testid={`alerts-type-${v || "all"}`}
            className={`rounded-full border px-4 py-1.5 text-sm ${type === v ? "border-rose-600 bg-rose-600 text-white" : "border-slate-200 bg-white text-slate-600"}`}>
            {l}{v && data?.counts?.[v] != null && type === "" ? ` · ${data.counts[v]}` : ""}
          </button>
        ))}
      </div>
      <ul className="mt-5 divide-y divide-slate-100 rounded-3xl border border-slate-200 bg-white">
        {!data && <li className="h-40 animate-pulse" />}
        {data?.items.map((a) => (
          <li key={a.id} className="flex flex-wrap items-start gap-3 p-4" data-testid={`alert-item-${a.id}`}>
            <span className="inline-flex items-center gap-1 rounded-md bg-rose-50 px-2 py-0.5 text-[11px] font-medium capitalize text-rose-700"><Siren size={11} />{a.alerts.join(" · ")}</span>
            <div className="min-w-0 flex-1">
              {a.cluster_alert ? (
                <button onClick={() => onOpenStory(a.cluster.id)} className="text-left font-medium text-slate-900 hover:text-sky-900">{a.title}</button>
              ) : (
                <a href={safeUrl(a.link)} target="_blank" rel="noopener noreferrer" className="font-medium text-slate-900 hover:text-sky-900">{a.title}</a>
              )}
              <p className="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-slate-500">
                <span>{a.cluster_alert ? `Fast-growing story · ${a.source}` : a.outlet || a.source}</span>
                {!a.cluster_alert && <SideChip side={a.source_type} />}
                <span>{timeAgo(a.published)}</span>{a.provinces?.length > 0 && <span>{a.provinces.join(", ")}</span>}
              </p>
            </div>
          </li>
        ))}
        {data?.items.length === 0 && <li className="p-8 text-center text-sm text-slate-500" data-testid="alerts-empty">No alerts of this type in the last 24 hours.</li>}
      </ul>
    </div>
  );
};
